export default {
  path: ":alias/treeNursings",
  component: resolve => require(["@/views/tree-nursings"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/tree-nursings/list"], resolve)
    }
  ]
};
